import { render, staticRenderFns } from "./FloatingComment.vue?vue&type=template&id=387b473b&scoped=true"
import script from "./FloatingComment.vue?vue&type=script&lang=ts"
export * from "./FloatingComment.vue?vue&type=script&lang=ts"
import style0 from "./FloatingComment.vue?vue&type=style&index=0&id=387b473b&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387b473b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('387b473b')) {
      api.createRecord('387b473b', component.options)
    } else {
      api.reload('387b473b', component.options)
    }
    module.hot.accept("./FloatingComment.vue?vue&type=template&id=387b473b&scoped=true", function () {
      api.rerender('387b473b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Viewer/Comments/FloatingComment.vue"
export default component.exports